var map = {
	"./music-instructions.json": 4652,
	"./music-library-intro2024.json": 4653,
	"./music-library-launch2024.json": 4654,
	"./music-progression.json": 4655,
	"./startSourcesAdvanced.json": 4656,
	"./startSourcesSimple.json": 4657,
	"./startSourcesSimple2.json": 4658,
	"./startSourcesTracks.json": 4659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4430;